<template>
  <div>
    <el-dialog :title="Title" custom-class="dialog" :visible.sync="dialogVisible" width="40%" append-to-body top='2vh' 
      :close-on-press-escape = "false" :close-on-click-modal = "false" >
      <el-form ref="form"  class="searchForm1" label-width="80px" size="small">
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="名称">
              <el-input v-model="name" placeholder="请输入名称，必填，不可为空"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="手机/电话">
              <el-input v-model="phone" placeholder="请输入手机/电话，必填，不可为空"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="24">
            <el-form-item label="备注信息">
              <el-input v-model="memo" placeholder="请输备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
            <el-col :span="24" style="text-align: center;margin-top: 10px;">
                <el-button type="primary" size="medium" @click="doSave" >保存</el-button>
                <el-button size="medium" @click="doCancel">取消</el-button>
            </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { Linq, S, DateFormat, TimeFormat } from "@/util/common";
import { AddOrUpdateContactInfoAndReturnContactID,IsContactPhoneExist} from "@/api/modules/basicData/baseTemplateInterface";
import { getToken } from "@/util/auth";
const cookieUser = getToken();
export default {
  data() {
    return {
      Title: "新增联系人",
      userId: cookieUser.userId,
      dialogVisible: false,
      name:'',
      phone:'',
      memo:'',

      editMode:0,//0：默认 1：编辑模板
      editModel:null,//待修改的PUB_TEMPLATE实体
    };
  },
  
  methods: {
    async checkData(){
      if(S(this.name).isEmpty()){
        this.$message({
          message: '请填写名称！',
          type: 'warning'
        });
        return false;
      }
      if(S(this.phone).isEmpty()){
        this.$message({
          message: '请填写手机/电话！',
          type: 'warning'
        });
        return false;
      }
      //修改时，检测号码是否已经存在
      let ret = await IsContactPhoneExist(this.phone,this.editMode == 1?this.editModel.ID:"");
      if(ret){
        this.$message({
          message: '手机/电话已经存在，请核对！',
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    async doSave(){
      let r = await this.checkData();
      if(!r){    
        return;
      }
      let para = this.getPara();
      
      AddOrUpdateContactInfoAndReturnContactID(JSON.stringify(para)).then(res=>{
        if(res == "-1"){
          this.$message.error('保存失败，请联系管理员！');
          return;
        }else{
          para.ID = res;
          this.$emit("successSubmit",para);
        }
        this.dialogVisible = false;
      }).catch(err=>{
        console.log("AddOrUpdateContactInfoAndReturnContactID err");
      })
    },
    doCancel(){
      this.dialogVisible = false;
    },
    getPara() {
      let para = {};
      if(this.editMode == 1){
        para.ID = this.editModel.ID;
      }
      para.Name = this.name;
      para.Telephone = [];
      para.Telephone.push({
        AllowPublic:true,
        Phone:this.phone,
        PhoneType:"手机号码"
      });
      para.Remarks = this.memo;
      para.IsEnable = 1;
      console.log("para is:",para);
      return para;
    },

    reset(tag = 0){  //0:重置所有数据，包括数据源  1：只清空填写与选择的结果    
      this.name = "";
      this.phone = "";
      this.memo = "";
      this.editMode = 0;
      this.editModel = null;
    },
    async SearchOpen(editData) {
      //打开窗口界面
      console.log("SearchOpen");
      this.dialogVisible = true;
      this.reset();
      // await this.init();
      // console.log("init end...");
      
      if(editData){  //编辑
          console.log("编辑Obj:",editData);
          this.editMode = 1;
          let{...emodel} = editData;
          this.editModel = emodel;
          //界面字段赋值
          this.name = emodel.Name;
          this.phone = emodel.Phone;
          this.Remarks = emodel.Remark;
      }
    },
  }
};
</script>

<style  scoped>
    .line{
        border: 0px solid red;
    }
    hr{
        margin: 0px;
        padding: 0px;
        margin-bottom: 5px;
        
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom: 8px;
    }
    .el-select {
        width: 100%;
    }
    .el-radio{
        margin-right: 15px;
    }
    .checkCreateExec >>> .el-checkbox-group{
        margin-top:6px;
        margin-left:20px;
    }
</style>
